import Header from '../components/header/header'
import CTASection from '../components/cta-section/cta-section'
import Footer from '../components/footer/footer'
import { HeadingWithDescription } from '../components/common/heading-with-description'
import { ContactForm } from '../components/contact-form/conatct-form'

export const ContactUs = () => {
  return (
    <div className='bg-[#000f2c]'>
      <Header />
      <HeadingWithDescription containerClass="py-10" headingOne="Contact" headingTow="Us" description="Any question or remarks? Just write us a message!"/>
      <ContactForm />
      <CTASection />
      <Footer />
    </div>
  )
}
